<mat-toolbar class="p-0 mat-elevation-z1 tphi" data-cy="toolbar">
    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center" *transloco="let t">
        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
            <button
                mat-icon-button
                class="navbar-toggle-button"
                *ngIf="!hiddenNavbar && !rightNavbar"
                (click)="toggleSidebarOpen('navbar')"
                fxHide.gt-md
            >
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>
            <div
                class="toolbar-separator"
                *ngIf="!hiddenNavbar && !rightNavbar"
                fxHide.gt-md
            ></div>
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                *ngIf="horizontalNavbar"
            ></div>
            <button
                class="home"
                mat-icon-button
                (click)="refresh()">
                <mat-icon class="accent-200-fg home">refresh</mat-icon>
            </button>

            <ng-container *ngIf="user && sub_type!='code_only'">
                <button
                    *accessControl="{ permissions: comptabilityPermissions['add-recette']}"
                    fxHide.md
                    fxHide.sm
                    fxHide.xs
                    mat-button
                    class="short-cut-button payment-btn mr-8"
                    (click)="addPayment()"
                    data-cy="add-candidat-payment"
                >
                    <mat-icon>add </mat-icon>
                    <span>{{t('toolbar.paimentcandidat')}}</span>
                </button>
            </ng-container>
            <ng-container *ngIf="user && sub_type!='code_only'">
                <button
                    *accessControl="{ permissions: comptabilityPermissions['add-depense']}"
                    fxHide.md
                    fxHide.sm
                    fxHide.xs
                    mat-button
                    class="short-cut-button reccete-btn mr-8"
                    (click)="addDepense()"
                    data-cy="add-expenses"
                >
                    <mat-icon>add </mat-icon>
                    <span>{{t('toolbar.masrouf')}} </span>
                </button>
            </ng-container>
            <ng-container>
                <button
                    *accessControl="{ permissions: candidatePermissions['add-candidat']}"
                    fxHide.md
                    fxHide.sm
                    fxHide.xs
                    mat-button
                    class="short-cut-button candidat-btn mr-8"
                    (click)="addCandidat()"
                    data-cy="add-candidat"
                >
                    <mat-icon>add </mat-icon>
                    <span> {{t('toolbar.candidat')}} </span>
                </button>
            </ng-container>
            <ng-container *ngIf="user && sub_type==='code_only'">
                <button
                    fxHide.md
                    fxHide.sm
                    fxHide.xs
                    mat-button
                    class="short-cut-button seance-btn"
                    (click)="planExamCode()"
                >
                <span>{{t('toolbar.examen')}} </span>
                <mat-icon>add </mat-icon>
                </button>
            </ng-container>
            <ng-container  *ngIf="user && sub_type!='code_only'">
                <button
                    data-cy="add-session"
                    fxHide.md
                    fxHide.sm
                    fxHide.xs
                    mat-button
                    class="short-cut-button seance-btn"
                    (click)="choose()"
                    *accessControl="{ 
                        permissions: [
                            calendarPermissions['add-occupied-event'],
                            calendarPermissions['add-code-session'],
                            calendarPermissions['add-code-exam'],
                            calendarPermissions['add-conduit-session'],
                            calendarPermissions['add-conduit-exam'],
                        ],
                        oneIsTrue: true}"
                >
                <span>{{t('toolbar.seance')}} </span>
                <mat-icon>add </mat-icon>
                </button>
<!-- Bulk planning button: opens a condensed 'Séance Conduite' form -->
                 <button
                    [newFeatureStyling]="'BulkPlanningButton-Toolbar'"
                    [newFeatureStylingHideAnimation]="calendarService.hideBulkAnimation()"
                    *accessControl="{ 
                        permissions: [
                            calendarPermissions['add-code-session'],
                            calendarPermissions['add-conduit-session'],
                        ],
                        oneIsTrue: true}"
                     fxHide.md
                     fxHide.sm
                     fxHide.xs
                     mat-button
                     class="short-cut-button bulk-btn"
                     (click)="openBulkSeance()"
                     title="Bulk - برنامج"
                 >
                     <mat-icon>add</mat-icon>
                     <span>{{t('toolbar.planning')}}</span>
                 </button>
            </ng-container>
            <ng-container *ngIf="user && sub_type!='code_only'">
                <button
                    *accessControl="{ permissions: comptabilityPermissions['add-recette']}"
                    fxHide.gt-md
                    mat-mini-fab
                    fxLayoutAlign="center center"
                    class="pay-sm-btn mr-8"
                    (click)="addPayment()"
                >
                    <mat-icon>arrow_downward </mat-icon>
                </button>
            </ng-container>
            <ng-container *ngIf="user && sub_type!='code_only'">
                <button
                    *accessControl="{ permissions: comptabilityPermissions['add-depense']}"
                    fxHide.gt-md
                    fxLayoutAlign="center center"
                    mat-mini-fab
                    class="rec-sm-btn mr-8"
                    (click)="addDepense()"
                >
                    <mat-icon>arrow_upward </mat-icon>
                </button>
            </ng-container>
            <ng-container>
                <button 
                    fxHide.gt-md
                    *accessControl="{ permissions: candidatePermissions['add-candidat']}"
                    mat-mini-fab
                    fxLayoutAlign="center center"
                    class="cand-sm-btn mr-8"
                    (click)="addCandidat()"
                >
                    <mat-icon>person_add</mat-icon>
                </button>
            </ng-container>
            <ng-container *ngIf="user && sub_type==='code_only'">
                <button
                    fxHide.gt-md
                    mat-mini-fab
                    fxLayoutAlign="center center"
                    class="sea-sm-btn mr-8"
                    (click)="planExamCode()"
                >
                    <mat-icon>event_available </mat-icon>
                </button>
            </ng-container>
            <ng-container *ngIf="user && sub_type!='code_only'">
                <button
                    fxHide.gt-md
                    *accessControl="{ 
                        permissions: [
                            calendarPermissions['add-occupied-event'],
                            calendarPermissions['add-code-session'],
                            calendarPermissions['add-code-exam'],
                            calendarPermissions['add-conduit-session'],
                            calendarPermissions['add-conduit-exam'],
                        ],
                        oneIsTrue: true}"
                    mat-mini-fab
                    fxLayoutAlign="center center"
                    class="sea-sm-btn mr-8"
                    (click)="choose()"
                >
                    <mat-icon>event_available </mat-icon>
                </button>
            </ng-container>
            <ng-container *ngIf="user && sub_type!='code_only'">
                <button
                    [newFeatureStyling]="'BulkPlanningButton-Toolbar'"
                    [newFeatureStylingHideAnimation]="calendarService.hideBulkAnimation()"
                    fxHide.gt-md
                    *accessControl="{ 
                        permissions: [
                            calendarPermissions['add-code-session'],
                            calendarPermissions['add-conduit-session'],
                        ],
                        oneIsTrue: true}"
                    mat-mini-fab
                    fxLayoutAlign="center center"
                    class="bulk-sm-btn mr-8" 
                    (click)="openBulkSeance()"
                >
                    <mat-icon [svgIcon]="'mat_outline:format_list_bulleted_add'"></mat-icon>
                    <!-- <span class="material-symbols-outlined bulk-icon" aria-hidden="true">format_list_bulleted_add</span> -->
                </button>
            </ng-container>
        </div>
        @if (showChip && !isBulkModeActive ) {
            <div class="participant-chip-container">
                    <mat-chip-set>
                        <mat-chip 
                            [matMenuTriggerFor]="currentEvents.length <= 1 ? null : aboveMenu"
                            class="participant-chip">
                                <mat-icon matChipAvatar>person</mat-icon>
                                <span>
                                    {{ chipLabel }}
                                </span>
                                <mat-progress-bar mode="query"></mat-progress-bar>
                        </mat-chip>
                    </mat-chip-set>
            </div>
            <!-- Custom Chip List Overlay -->
             <mat-menu #aboveMenu="matMenu">
                @for (event of currentEvents; track event.id; let i = $index) {
                    <div class="participant-element">
                        <mat-icon matChipAvatar>person</mat-icon>
                        <span>
                            {{ event.candidateName }}
                        </span>
                    </div>
                }
            </mat-menu>
        }
        <div
            class="tphi"
            fxFlex="0 1 auto"
            fxLayout="row"
            fxLayoutAlign="start center"
        >
            <button
                [matMenuTriggerFor]="userMenu"
                class="user-button"
            >
                <img 
                    class="piclass"
                    src = "{{uriG}}/image/small/{{user.image}}"
                    alt="ton image"
                />
            </button>

            @if (showTranslationButton) {
                <app-language-selector></app-language-selector>
            }


            <button mat-icon-button class="settings-btn icon-button" [matMenuTriggerFor]="settingsMenu">
                <mat-icon class="icon">settings</mat-icon>
            </button>

            <button mat-icon-button class="help-btn icon-button" (click)="goToHelp()">
                <mat-icon class="icon">help</mat-icon>
            </button>
            <!-- <button mat-icon-button class="help-btn icon-button hide-in-small " (click)="toggleCurrentTheme()">
                <mat-icon *ngIf="currentTheme == 'dark'" class="icon">light_mode</mat-icon>
                <mat-icon *ngIf="currentTheme == 'light'" class="icon">dark_mode</mat-icon>
            </button> -->

            
            <button
                mat-icon-button
                class="icon-button"
                (click)="toggleSidebarOpen('quickPanel'); opened(); scrollUp()"
            >
                <mat-icon
                    class="icon"
                    [matBadgeHidden]="badgeHidden"
                    matBadge="{{ notNumber }}"
                >
                    notifications_none</mat-icon
                >
            </button>
            <button
                mat-icon-button
                class="navbar-toggle-button"
                *ngIf="!hiddenNavbar && rightNavbar"
                (click)="toggleSidebarOpen('navbar')"
                fxHide.gt-md
            >
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>
        </div>
    </div>
</mat-toolbar>

<mat-menu #userMenu="matMenu" xPosition="before">
    <button mat-menu-item [routerLink]="'/administration/account'">
        <mat-icon>account_circle</mat-icon>
        <span *transloco="let t"> {{t('toolbar.moncompte')}}</span>
    </button>

    <button mat-menu-item class="" (click)="authService.logOut()">
        <mat-icon [ngStyle]="{ transform: translocoService.getActiveLang() === 'ar' ? 'rotate(180deg)' : 'rotate(0deg)' }">exit_to_app</mat-icon>
        <span *transloco="let t">{{t('toolbar.logout')}}</span>
    </button>
</mat-menu>

<mat-menu #settingsMenu="matMenu" xPosition="before">
    <ng-container *ngFor="let item of settingsItems">
        <button 
            *ngIf="item.show"
            mat-menu-item 
            [routerLink]="item.route ? item.route : null"
            [queryParams]="item?.routeParams ? item.routeParams : null"
            (click)="item.callback ? item.callback() : null"
        >
            @if (item.name === 'online-service') {
                <mat-icon svgIcon="mat_outline:travel_explore"></mat-icon>
            } @else {
                <mat-icon>{{ item.icon }}</mat-icon>
            }
            <span *transloco="let t">{{ item.label.startsWith('countrySettings.') ? t(item.label) : t('toolbar.' + item.label) }}</span>
        </button>
    </ng-container>

</mat-menu>
